module.exports = __webpack_public_path__ + "assets/5b3b88d1c979bd16a45578d20889d9f6.png";